import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabstaxibanglore() {



  const cardData =
  {
    keyword: ' Corporate Cabs Taxi Bangalore',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cabs Taxi Bangalore',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cabs Taxi services in Bangalore, designed to meet the transportation needs of corporate offices, IT parks, business centers, and industrial units across the city. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and timely travel for employees, clients, and senior executives. Whether it is daily office commute, airport transfers, inter-office travel, business meetings, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Bangalore.',

    top: 'Top Places to Visit in Bangalore with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Bangalore Palace",
    "description": "Bangalore Palace is an architectural marvel inspired by England’s Windsor Castle, built in the 19th century. The palace features Tudor-style architecture, fortified towers, elegant woodwork, and sprawling gardens. Visitors can explore the royal interiors, vintage furniture, and photo galleries. The palace also hosts cultural events, music concerts, and exhibitions, offering a blend of history, art, and heritage in the heart of Bangalore."
  },
  {
    "title": "Lalbagh Botanical Garden",
    "description": "Lalbagh Botanical Garden is a 240-acre green oasis in Bangalore, famous for its diverse collection of flora, centuries-old trees, glasshouse, and flower shows. The garden offers walking paths, serene lakes, and picturesque landscapes, making it ideal for nature lovers, photographers, and families. Seasonal flower exhibitions attract visitors from across the city and beyond."
  },
  {
    "title": "Cubbon Park",
    "description": "Cubbon Park is a lush, sprawling park in central Bangalore, covering over 300 acres. With walking trails, jogging paths, playgrounds, and abundant greenery, it serves as a popular recreational spot for locals and tourists alike. The park also houses several government buildings and statues, creating a perfect blend of nature, culture, and history in the city."
  },
  {
    "title": "Vidhana Soudha",
    "description": "Vidhana Soudha is an iconic government building and a symbol of Bangalore’s political and architectural heritage. Built in a Neo-Dravidian style, it features grand pillars, domes, and intricately carved stonework. Visitors admire the building’s majestic facade, especially during evening lightings. Though entry is restricted, the surrounding area and viewpoints provide excellent photo opportunities."
  },
  {
    "title": "ISKCON Temple Bangalore",
    "description": "The ISKCON Temple is a major spiritual and cultural center in Bangalore, dedicated to Lord Krishna. The temple complex features traditional architecture, colorful murals, a large prayer hall, and beautiful gardens. Visitors can attend devotional ceremonies, participate in cultural programs, and enjoy vegetarian meals at the temple’s food court. It is a serene escape for meditation and spiritual learning in the bustling city."
  },
  {
    "title": "Commercial Street",
    "description": "Commercial Street is Bangalore’s bustling shopping hub, offering a variety of clothing, footwear, jewelry, accessories, and street food. It is popular among locals and tourists looking for shopping, bargain hunting, and exploring vibrant street markets. The lively atmosphere, diverse shops, and colorful storefronts make it a must-visit for retail enthusiasts."
  },
  {
    "title": "Bannerghatta National Park",
    "description": "Bannerghatta National Park is a major wildlife destination near Bangalore, featuring a zoo, butterfly park, safari rides, and trekking trails. Visitors can observe lions, tigers, elephants, and a variety of other animals in naturalistic settings. The park is perfect for families, wildlife enthusiasts, and students seeking educational and recreational experiences close to the city."
  },
  {
    "title": "Ulsoor Lake",
    "description": "Ulsoor Lake is a picturesque water body located in central Bangalore, ideal for boating, photography, and evening strolls. The lake is surrounded by lush greenery, walking paths, and small islands. It is a peaceful spot for relaxation, picnics, and spending time with family or friends, offering a serene escape within the urban landscape."
  },
  {
    "title": "Nandi Hills",
    "description": "Located on the outskirts of Bangalore, Nandi Hills is a scenic hill station known for its sunrise views, trekking trails, and historical sites like Tipu Sultan’s Summer Palace. The hill offers a refreshing escape from the city heat, with cool breezes, lush landscapes, and panoramic vistas. It is a favorite destination for nature lovers, photographers, and adventure seekers."
  },
  {
    "title": "Wonderla Amusement Park",
    "description": "Wonderla is one of India’s top amusement parks, located near Bangalore, offering thrilling rides, water slides, and family entertainment zones. The park is ideal for a fun-filled day with family and friends, featuring safe rides, adventure zones, and well-maintained facilities. Seasonal events and themed attractions make it a popular destination for locals and tourists seeking excitement and leisure."
  }
],


"services": [
{
"name": "Corporate Taxi Bangalore",
"description": "Corporate Taxi Bangalore offers a fully managed and professional taxi service designed for companies requiring reliable employee transportation and executive travel. With a dedicated fleet of sedans, SUVs, and premium vehicles, along with trained chauffeurs, GPS-enabled tracking, on-time assurance, automated route planning, and 24/7 operational support, this service ensures seamless mobility for corporate teams across all major business hubs, IT parks, and industrial zones in Bangalore."
},
{
"name": "Business Cabs Bangalore",
"description": "Business Cabs Bangalore provides tailored transportation solutions for business travelers, corporate teams, and executives who require punctual, safe, and comfortable travel for meetings, site visits, conferences, and daily office commutes. The service includes high-quality vehicles, verified drivers, real-time tracking, route optimization, and flexible booking options, ensuring smooth mobility throughout Bangalore’s commercial corridors."
},
{
"name": "Office Pickup Drop Taxi Bangalore",
"description": "Office Pickup Drop Taxi Bangalore delivers structured daily employee commute solutions with well-planned routes, punctual pickups, safe drop-offs, real-time monitoring, and compliance-focused fleet operations. Designed for companies of all sizes, it ensures efficient workforce movement with features like intelligent scheduling, automated driver allocation, and GPS-based safety systems."
},
{
"name": "Employee Commute Taxi Bangalore",
"description": "Employee Commute Taxi Bangalore focuses on daily employee transportation with reliable cabs, expert drivers, and technology-driven tracking systems. The service ensures employees reach the office on time and return home safely using optimized routes, shift-based scheduling, and robust safety protocols suited for IT, corporate, and industrial organizations."
},
{
"name": "Staff Transportation Taxi Bangalore",
"description": "Staff Transportation Taxi Bangalore provides organized staff mobility solutions built for large corporate teams, factories, BPOs, and IT companies. With real-time monitoring, structured routing, driver management, and multi-shift operations, it ensures safe, punctual, and hassle-free transportation for employees across Bangalore."
},
{
"name": "Company Taxi Rental Bangalore",
"description": "Company Taxi Rental Bangalore offers dedicated long-term taxi rental solutions for corporations requiring on-site mobility, executive travel, client movement, and employee transportation. With fixed monthly plans, managed fleet operations, professional chauffeurs, and maintenance-inclusive packages, it provides consistent and cost-efficient mobility for businesses."
},
{
"name": "Airport Taxi Corporate Bangalore",
"description": "Airport Taxi Corporate Bangalore specializes in corporate airport transfers with reliable pickup–drop services, flight tracking, professional chauffeurs, well-maintained sedans/SUVs, and 24/7 availability. Ideal for executives, business travelers, and corporate guests, it ensures smooth, timely, and comfortable airport transit across Bangalore."
},
{
"name": "Outstation Taxi Bangalore",
"description": "Outstation Taxi Bangalore offers dependable long-distance corporate travel for business trips, client meetings, intercity transfers, and executive tours. With experienced drivers, comfortable vehicles, route monitoring, and safety-focused operations, it ensures smooth corporate journeys to major destinations across Karnataka and neighboring states."
},
{
"name": "Monthly Taxi Rental Bangalore",
"description": "Monthly Taxi Rental Bangalore provides flexible monthly taxi subscription plans for companies needing dedicated vehicles for employee commute, business travel, or corporate operations. The service includes driver deployment, maintenance, GPS tracking, and standby fleet support, ensuring uninterrupted mobility throughout the month."
},
{
"name": "Best Corporate Taxi Bangalore",
"description": "Best Corporate Taxi Bangalore delivers premium corporate mobility solutions with top-rated vehicles, trained chauffeurs, professional service standards, and strict safety compliance. Designed for executive-level travel and corporate staff movement, it ensures reliability, comfort, and consistently high service quality."
},
{
"name": "Affordable Taxi Bangalore",
"description": "Affordable Taxi Bangalore offers cost-effective corporate taxi services without compromising on safety, punctuality, or comfort. With well-maintained vehicles, transparent pricing, optimized routes, and real-time tracking, it delivers value-driven transportation solutions for startups, SMEs, and large enterprises."
},
{
"name": "Executive Taxi Bangalore",
"description": "Executive Taxi Bangalore provides high-end taxi services featuring premium sedans, luxury vehicles, and professionally trained chauffeurs. Tailored for senior executives, business leaders, and VIP guests, the service ensures superior comfort, privacy, punctuality, and a refined travel experience across Bangalore."
},
{
"name": "Corporate Sedan Taxi Bangalore",
"description": "Corporate Sedan Taxi Bangalore offers comfortable, spacious, and executive-grade sedans ideal for daily commute, corporate meetings, and client travel. With trained chauffeurs, GPS tracking, and premium interiors, it ensures a professional and comfortable transportation experience for corporate clients."
},
{
"name": "SUV Taxi Bangalore",
"description": "SUV Taxi Bangalore provides robust, spacious, and premium SUVs for corporate teams, field operations, business trips, and long-distance travel. Equipped with high-comfort seating, safety features, and professional drivers, it is ideal for executive mobility and group travel requirements."
},
{
"name": "Chauffeur Taxi Bangalore",
"description": "Chauffeur Taxi Bangalore offers professionally chauffeured taxi services with highly trained drivers, executive-grade vehicles, and tailored travel experiences. Designed for corporate executives, business travelers, and VIP clients, it ensures maximum safety, comfort, privacy, and punctuality in every trip."
}
],

"tableData": [
["Corporate Taxi Bangalore", "Business Cabs Bangalore"],
["Office Pickup Drop Taxi Bangalore", "Employee Commute Taxi Bangalore"],
["Staff Transportation Taxi Bangalore", "Company Taxi Rental Bangalore"],
["Airport Taxi Corporate Bangalore", "Outstation Taxi Bangalore"],
["Monthly Taxi Rental Bangalore", "Best Corporate Taxi Bangalore"],
["Affordable Taxi Bangalore", "Executive Taxi Bangalore"],
["Corporate Sedan Taxi Bangalore", "SUV Taxi Bangalore"],
["Chauffeur Taxi Bangalore", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cabs Taxi Bangalore",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable corporate taxi services in Bangalore, ensuring smooth and efficient transportation for employees and business executives."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We guarantee on-time pickups and drop-offs across Bangalore’s IT parks, commercial hubs, and industrial areas, helping professionals reach their destinations without delays."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs offer safe, courteous, and disciplined travel, ensuring a comfortable and secure commuting experience for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for reliable corporate travel."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We provide flexible taxi rental plans tailored to meet the commuting needs of businesses and employees in Bangalore."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team is available round-the-clock for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, offering secure and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is managed effortlessly through our streamlined booking process and reliable coordination, making employee transport hassle-free."
  }
]































  }

const faqData = [
  {
    question: 'Do you offer corporate cabs and taxi services in Bangalore?',
    answer: 'Yes, Pune Corporate Cars India Private Limited provides reliable and professional corporate cabs and taxi services for companies and employees across Bangalore.',
  },
  {
    question: 'What types of corporate taxi services are available in Bangalore?',
    answer: 'We offer employee transportation, corporate pickups and drops, airport taxi services, shuttle routes, and fully managed fleet solutions.',
  },
  {
    question: 'Do you support daily office commute services in Bangalore?',
    answer: 'Yes, we provide daily commute services with timely pickups, optimized routing, and shift-based transportation for employees.',
  },
  {
    question: 'How can companies book corporate cabs or taxis in Bangalore?',
    answer: 'Bookings can be made easily through our website, mobile app, or via our 24×7 corporate support team.',
  },
  {
    question: 'What vehicles are available under corporate cab and taxi services?',
    answer: 'We offer sedans, hatchbacks, SUVs, luxury cars, Innova Crysta, tempo travellers, and staff shuttles depending on corporate requirements.',
  },
  {
    question: 'Can companies opt for long-term corporate taxi service contracts?',
    answer: 'Yes, we provide flexible monthly, quarterly, and annual corporate transportation contracts.',
  },
  {
    question: 'Are your corporate taxis equipped with safety and tracking features?',
    answer: 'All our vehicles include GPS tracking, real-time monitoring, verified chauffeurs, and regular sanitization for safety.',
  },
  {
    question: 'Do you manage multi-shift employee transportation in Bangalore?',
    answer: 'Absolutely. We support early morning, regular, night, and rotational shift transportation for corporate staff.',
  },
  {
    question: 'What payment options are available for corporate taxi services?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and offer consolidated corporate invoices.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Kiran Prakash',
    feedback: 'Fantastic corporate cab service in Bangalore. Timely pickups and excellent driver professionalism made our daily commute smooth.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Rao',
    feedback: 'Very reliable and efficient corporate taxi service. Vehicles are clean, well-maintained, and perfect for corporate travel.',
    rating: 5,
  },
];

































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cabs Taxi Bangalore",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-bangalore.jpg", // replace with correct image if needed
  "description":
    "Pune Corporate Cars India Private Limited provides reliable corporate cab and taxi services in Bangalore, including employee commute, office pickup & drop, business cabs, airport transfers, outstation trips, monthly rentals, executive chauffeur-driven taxis, and corporate fleet solutions for companies operating in Bangalore.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cabs-taxi-bangalore"
  }
};








  return (
    <div>

<Helmet>
  <title>Corporate Cabs Taxi Bangalore | Employee & Business Transport</title>

  <meta
    name="description"
    content="Premium corporate cab and taxi services in Bangalore including employee commute, office pickup & drop, business cabs, airport transfers, outstation trips, monthly taxi rentals, executive chauffeur-driven cars, and corporate fleet solutions."
  />

  <meta
    name="keywords"
    content="Corporate Taxi Bangalore, Business Cabs Bangalore, Office Pickup Drop Taxi Bangalore, Employee Commute Taxi Bangalore, Staff Transportation Taxi Bangalore, Company Taxi Rental Bangalore, Airport Taxi Corporate Bangalore, Outstation Taxi Bangalore, Monthly Taxi Rental Bangalore, Best Corporate Taxi Bangalore, Affordable Taxi Bangalore, Executive Taxi Bangalore, Corporate Sedan Taxi Bangalore, SUV Taxi Bangalore, Chauffeur Taxi Bangalore"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/114.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabstaxibanglore;